// Raw SELECT wire contracts shared by the location tables and the world cards.
import { decodeHtmlEntitiesForPlainText } from '../shared/decode-html-entities';
import { compilePictureRow } from '../janus-engine/compile/picture-row-construction';
import { resolveUrl } from './catalog-list';

export interface LocationListRow {
    location_id: string;
    location_name: string | null;
    location_private: number | string | null;
    location_deleted: number | string | null;
    location_created_by_id: string | null;
    location_master_parent_id: string | null;
    location_parent_id: string | null;
    location_parent_name: string | null;
    location_type: string | null;
    location_type_name: string | null;
    location_world: number | string | null;
    location_zone_prefix: string | null;
    location_description: string | null;
    location_picture_id: string | null;
    location_picture_extension: string | null;
    location_picture_reference_attached_item_type: string | null;
    location_map_id: string | null;
    location_map_extension: string | null;
    location_map_reference_attached_item_type: string | null;
    location_place_count: number | string | null;
    location_active_place_count: number | string | null;
}
export interface LocationListResponse {
    schema: 'location-list-v1';
    mode: 'my' | 'template' | 'browse' | 'guest-sample';
    locations: LocationListRow[];
    readable_parent_ids: string[];
    csrf_token?: string;
    total: number;
}
export interface WorldListResponse {
    schema: 'world-list-v1';
    mode: 'my' | 'browse';
    worlds: LocationListRow[];
    viewer_is_admin?: boolean;
    csrf_token?: string;
    total: number;
}

export const listText = (value: unknown): string => decodeHtmlEntitiesForPlainText(value);
export const locationUrl = (id: string): string => resolveUrl(`location.php?location_id=${encodeURIComponent(id)}`);
export const editLocationUrl = (id: string): string => resolveUrl(`tools/locations/modify_location.php?location_id=${encodeURIComponent(id)}`);

/** Use the canonical picture reference-folder rules; only the ordered cover row is needed by these lists. */
export function locationPictureUrl(row: LocationListRow, map = false): string {
    const id = map ? row.location_map_id : row.location_picture_id;
    if (!id) return '';
    const picture = compilePictureRow({
        picture_id: id,
        picture_extension: map ? row.location_map_extension : row.location_picture_extension,
        picture_attached_item_type: map ? 'location_map' : 'location_picture',
        picture_reference_attached_item_type: map ? row.location_map_reference_attached_item_type : row.location_picture_reference_attached_item_type,
    }, { cdnUrl: BASE_URL_CDN });
    return String((picture as Readonly<Record<string, unknown>>).picture_url ?? '');
}
